import { render, staticRenderFns } from "./TotalMediaInteractions.vue?vue&type=template&id=2cd39dff&"
import script from "./TotalMediaInteractions.vue?vue&type=script&lang=js&"
export * from "./TotalMediaInteractions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports